import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", testid }) {
  return (
    <motion.div
      className={className}
      data-testid={testid}
      initial={{ opacity: 0, y: 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.75, delay, ease: [0.19, 1, 0.22, 1] }}
    >
      {children}
    </motion.div>
  );
}

// Pretítulo global: una línea corta y discreta a cada lado del texto
export function Pretitulo({ children, claro = false, center = true }) {
  return (
    <div className={`flex items-center ${center ? "justify-center" : ""}`}>
      <span className={`pretitulo ${claro ? "pretitulo--claro" : ""}`}>{children}</span>
    </div>
  );
}

export function TituloSeccion({ pre, titulo, claro = false, center = true, className = "" }) {
  return (
    <Reveal className={`mb-10 md:mb-14 ${center ? "text-center" : ""} ${className}`}>
      <Pretitulo claro={claro} center={center}>{pre}</Pretitulo>
      <h2
        className={`mt-4 font-serif font-light tracking-tight text-3xl sm:text-4xl lg:text-5xl ${
          claro ? "text-sand" : "text-ink"
        }`}
      >
        {titulo}
      </h2>
    </Reveal>
  );
}

// Botón primario / secundario coherentes en todo el sitio
export function BtnPrimario({ children, href, onClick, testid, tipo = "button" }) {
  const cls =
    "inline-flex items-center justify-center gap-2 bg-terra px-7 py-3.5 text-[11px] font-bold tracking-[0.22em] text-sand transition-all duration-300 hover:bg-terra-dark hover:shadow-lg hover:shadow-terra/25";
  if (href)
    return (
      <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className={cls} data-testid={testid}>
        {children}
      </a>
    );
  return (
    <button type={tipo} onClick={onClick} className={cls} data-testid={testid}>
      {children}
    </button>
  );
}

export function BtnSecundario({ children, href, onClick, testid, claro = false }) {
  const cls = `inline-flex items-center justify-center gap-2 border px-7 py-3.5 text-[11px] font-bold tracking-[0.22em] transition-all duration-300 ${
    claro
      ? "border-sand/70 text-sand hover:bg-sand hover:text-ink"
      : "border-ink/30 text-ink hover:border-terra hover:text-terra"
  }`;
  if (href)
    return (
      <a href={href} className={cls} data-testid={testid}>
        {children}
      </a>
    );
  return (
    <button type="button" onClick={onClick} className={cls} data-testid={testid}>
      {children}
    </button>
  );
}